// @ts-nocheck
import * as Types from '../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type SaveTradePartnerContactUserMutationVariables = Types.Exact<{
  input: Types.SaveTradePartnerContactInput;
}>;


export type SaveTradePartnerContactUserMutation = { __typename?: 'Mutation', saveTradePartnerContact: { __typename?: 'SaveTradePartnerContactResult', tradePartnerContact: { __typename?: 'TradePartnerContact', id: string, canLoginToPortal: boolean, tradePartnerUser?: { __typename?: 'TradePartnerUser', id: string } | null | undefined } } };


export const SaveTradePartnerContactUserDocument = gql`
    mutation SaveTradePartnerContactUser($input: SaveTradePartnerContactInput!) {
  saveTradePartnerContact(input: $input) {
    tradePartnerContact {
      id
      canLoginToPortal
      tradePartnerUser {
        id
      }
    }
  }
}
    `;

/**
 * __useSaveTradePartnerContactUserMutation__
 *
 * To run a mutation, you first call `useSaveTradePartnerContactUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveTradePartnerContactUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveTradePartnerContactUserMutation, { data, loading, error }] = useSaveTradePartnerContactUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveTradePartnerContactUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveTradePartnerContactUserMutation, SaveTradePartnerContactUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveTradePartnerContactUserMutation, SaveTradePartnerContactUserMutationVariables>(SaveTradePartnerContactUserDocument, options);
      }
export type SaveTradePartnerContactUserMutationHookResult = ReturnType<typeof useSaveTradePartnerContactUserMutation>;
export type SaveTradePartnerContactUserMutationResult = ApolloReactCommon.MutationResult<SaveTradePartnerContactUserMutation>;